var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import { UserCircleIcon } from '@heroicons/react/24/outline';
import { Save } from 'lucide-react';
var ProfileSettings = function (_a) {
    var editUser = _a.editUser, onInputChange = _a.onInputChange, onSave = _a.onSave, isDirty = _a.isDirty, emailValid = _a.emailValid, whatsappValid = _a.whatsappValid, formatWhatsappInput = _a.formatWhatsappInput;
    var _b = useState(false), isSaving = _b[0], setIsSaving = _b[1];
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsSaving(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, onSave()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    console.error('Erro ao salvar:', error_1);
                    return [3 /*break*/, 5];
                case 4:
                    setIsSaving(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // ✅ Botão ativo somente se houver alterações E validações OK
    var isButtonEnabled = isDirty && emailValid && whatsappValid && !isSaving;
    return (React.createElement("section", { className: "flex flex-col gap-6 w-full bg-gradient-to-r from-blue-900/60 via-gray-800/80 to-blue-900/60 rounded-2xl px-2 py-4 md:p-8 shadow-lg border border-blue-400/20" },
        React.createElement("h2", { className: "text-2xl font-bold text-blue-300 flex items-center gap-2" },
            React.createElement(UserCircleIcon, { className: "w-7 h-7 text-blue-400" }),
            "Perfil"),
        React.createElement("div", null,
            React.createElement("label", { className: "block text-sm font-semibold mb-2 text-blue-200" }, "Nome"),
            React.createElement("input", { type: "text", name: "first_name", value: editUser.first_name, onChange: onInputChange, className: "w-full bg-gray-700/80 rounded-lg px-4 py-3 text-white font-semibold text-lg border border-blue-400/20 focus:outline-none focus:border-blue-400/60 transition" })),
        React.createElement("div", null,
            React.createElement("label", { className: "block text-sm font-semibold mb-2 text-blue-200" }, "WhatsApp"),
            React.createElement("div", { className: "relative flex items-center" },
                React.createElement("span", { className: "absolute left-3 text-gray-400 font-bold select-none" }, "+55"),
                React.createElement("input", { type: "text", name: "whatsapp_number", value: formatWhatsappInput((editUser.whatsapp_number || "").replace(/^55/, "")), onChange: function (e) {
                        var digitsOnly = e.target.value.replace(/\D/g, "").slice(0, 11);
                        var fakeEvent = {
                            target: {
                                name: 'whatsapp_number',
                                value: digitsOnly
                            }
                        };
                        onInputChange(fakeEvent);
                    }, className: "w-full pl-12 pr-4 py-3 bg-gray-700/80 rounded-lg text-white font-semibold text-lg border border-blue-400/20 focus:outline-none focus:border-blue-400/60 transition", placeholder: "(00) 00000-0000", maxLength: 16 })),
            React.createElement("span", { className: "text-xs text-gray-400 mt-1 block" }, "Informe apenas n\u00FAmeros. Exemplo: (61) 99999-9999")),
        React.createElement("div", null,
            React.createElement("label", { className: "block text-sm font-semibold mb-2 text-blue-200" }, "E-mail"),
            React.createElement("input", { type: "email", name: "email", value: editUser.email, onChange: onInputChange, className: "w-full bg-gray-700/80 rounded-lg px-4 py-3 text-white font-semibold text-lg border border-blue-400/20 focus:outline-none focus:border-blue-400/60 transition" })),
        React.createElement("button", { className: "font-bold py-3 px-6 rounded-lg shadow-lg transition group ".concat(isButtonEnabled
                ? 'bg-blue-600 hover:bg-blue-700 text-white hover:scale-105 active:scale-95 cursor-pointer'
                : 'bg-gray-600/50 text-gray-400 cursor-not-allowed opacity-50'), onClick: handleSave, disabled: !isButtonEnabled, title: !isDirty
                ? 'Nenhuma alteração detectada'
                : !emailValid
                    ? 'E-mail inválido'
                    : !whatsappValid
                        ? 'WhatsApp inválido'
                        : 'Salvar alterações' }, isSaving ? (React.createElement("span", { className: "flex items-center justify-center gap-2" },
            React.createElement("svg", { className: "animate-spin h-5 w-5", viewBox: "0 0 24 24" },
                React.createElement("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4", fill: "none" }),
                React.createElement("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8v8z" })),
            "Salvando...")) : (React.createElement("span", { className: "flex items-center justify-center gap-2" },
            React.createElement(Save, { className: "w-5 h-5 transition-transform duration-200 group-hover:scale-110 group-hover:rotate-12" }),
            "Salvar Altera\u00E7\u00F5es")))));
};
export default ProfileSettings;
